import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import Arrow from '../components/svg/Arrow';
import { responsive } from '../resources/constantes.json';


const DropdownSelectorPropiedades = ({ atts, vars, elec }) => {
  let [isOpen, setIsOpen] = useState(false);

  const generarListaPropiedades=()=>{
    let listaPropiedades =[];
    atts.lista.map(x=>{
      x.lista.map(y=>{
        const propiedad={'titulo':x.titulo, 'tipo': x.tipo, 'objeto':y}
        if(elec === "7" && y.tipo === "VP"){
          // Citrep no tiene votos a agrupación politica
        } else {
          listaPropiedades.push(propiedad);
        }
      })
    })
    return listaPropiedades;
  };

  let propiedades = [];
  propiedades=generarListaPropiedades();
  let estadisticaSeleccionada = propiedades.find(x=>(x.objeto.tipo === vars.vars[1] &&x.tipo === vars.vars[0]));
  let propiedadSeleccionada = estadisticaSeleccionada.titulo + " "+estadisticaSeleccionada.objeto.nombre;


  const handleSelection = (event) => {
    setIsOpen(false)
    vars.funs[0](event.tipo);
    vars.funs[1](event.objeto.tipo);
  };
  return (
    <ContainerPropiedades>
    <SWrapper
    onSelection={handleSelection.bind(this)}
    onMenuToggle={() => {
      isOpen = !isOpen;
      setIsOpen(isOpen)}}
    >
      <SH3>{atts.titulo}</SH3>
      <SButton>
        <h3>{propiedadSeleccionada}
        </h3>
        {propiedades.length > 1 && (
          <Arrow variant={isOpen ? 'up' : 'down'} fill="#112F50" />
        )}
      </SButton>
      <SMenu>
        {propiedades.length > 1 &&
          propiedades.map((x, i) => {
            return (
              <SMenuItem
                value={x}
                key={i + x.tipo}
              >
               {x.titulo} {x.objeto.nombre}
              </SMenuItem>
            );
          })}
      </SMenu>
    </SWrapper>
    </ContainerPropiedades>
  );
};

export default DropdownSelectorPropiedades;

const ContainerPropiedades = styled(({ primerColor, ...rest }) => (
  <div {...rest} />
))`
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: #fff;
  // border-bottom: 10px solid ${({ primerColor }) => (primerColor)};
  @media (max-width: ${responsive.mobile}px) {
    background: white;
  }
`;

const SWrapper = styled(Wrapper)`
  width: 100%;
  position: relative;
  background: #fff;
  border: 1px solid #C2D2F1;
  border-radius: 3px;
  margin-top: 0;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
  // z-index: 1;
  //height: 6.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  & > div:first-child,
  span {
    padding-left: 1rem;
    box-sizing: border-box;
    height: 44px;
    width: 100%;
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    //height: 3.5rem;
  }
`;

const SButton = styled(Button)`
  border: 1px solid #C2D2F1;
  border-radius: 3px;
  width:100%;
  color: #283f5f;
  display: flex;
  align-items: center;
  cursor: pointer;
  & h3 {
    font-size: 1.4rem;;
    font-weight: 400;
    color: #112f50;
  }
  & svg {
    margin-left: auto;
    line-height: 2rem;
    height: 2rem;
    margin-right: 2%;
  }
`;
const SH3 = styled.h3`
  font-size: 1.6rem;
  font-weight: 500;
  margin: 15px 0;
  text-transform: uppercase;
  color: #283f5f;
`;
const SMenu = styled(Menu)`
  position: absolute;
  width: 100%;
  top: 90px;
  z-index: 2;
  background: #f3f3f3;
  box-shadow: 0 10px 6px -5px rgba(0, 0, 0, 0.1);
  & > * {
    text-align: left;
  }
  & h4 {
    text-transform: uppercase;
    font-size: 1.5rem;
    font-weight: 800;
    color: #283f5f;
    padding: 0.5rem 0;
    //box-shadow: inset 0 0px 10px 0px rgba(0, 0, 0, 0.1);
    :last-child {
      margin: 0.3rem 0;
    }
  }
`;

const SMenuItem = styled(MenuItem)`
  font-size: 1.4rem;
  padding: 0.8rem 1rem;
  cursor: pointer;
  :hover{
    color:#fff;
    background-color:#112F50; 
  }
`;
